import { forwardRef } from "react";
import cn from "mcn";

export const LiveChartsOutlined = forwardRef<
  SVGSVGElement,
  React.SVGProps<SVGSVGElement> & {
    size?: number | string;
    fill?: string;
    disableHover?: boolean;
  }
>(function LiveChartsOutlined({ size, className, style, fill, disableHover, ...props }, ref) {
  return (
    // biome-ignore lint/a11y/noSvgWithoutTitle: decorative icon
    <svg
      width={size}
      height={size}
      viewBox="0 0 15 15"
      fill={fill}
      xmlns="http://www.w3.org/2000/svg"
      className={cn(className)}
      style={style}
      ref={ref}
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M3.24141 4.41977C3.47683 4.41978 3.82325 4.56874 3.82342 4.82396V7.02071H5.07658V11.7152H3.82342V13.6004C3.82335 13.8556 3.47669 14.0622 3.24141 14.0625C3.00593 14.0625 2.6848 13.8557 2.68473 13.6004V11.7152H1.40625V7.02071H2.68958L2.68861 7.01544V4.82396C2.68878 4.56882 3.0061 4.41991 3.24141 4.41977ZM2.68473 10.6374H3.82342V8.09856H2.68861L2.68473 10.6374Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M7.37035 0.9375C7.73078 0.937434 7.99015 1.14435 7.99031 1.39958V2.60479H9.08178V6.82987H7.99031V9.40344C7.99017 9.6586 7.67908 9.89176 7.44376 9.89192C7.20831 9.89192 6.8754 9.65028 6.87527 9.39502V6.82987H5.67057V2.60479H6.87138V1.39958C6.87155 1.14438 7.13496 0.937543 7.37035 0.9375ZM6.87527 5.75202H7.99031V3.68264H6.87527V5.75202Z"
        fill={fill}
      />
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M11.7547 4.60881C11.9901 4.60882 12.3365 4.75778 12.3367 5.013L12.3406 6.72566H13.5938V10.4813H12.9672H12.3406V12.9122C12.3405 13.1674 11.9939 13.374 11.7586 13.3743C11.5231 13.3743 11.202 13.1675 11.2019 12.9122V10.4813H9.92342V6.72566H11.2058V6.32722L11.2019 5.013C11.2021 4.75786 11.5194 4.60894 11.7547 4.60881ZM11.2019 9.94917H12.3406V7.41033H11.2058L11.2019 9.94917Z"
        fill={fill}
      />
    </svg>
  );
});
